import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import { ConditionalWrapper } from '../../primitives/ConditionalWrapper/ConditionalWrapper.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import { Flex } from '../Flex/Flex.es.js';
import { List } from '../List/List.es.js';
import Popover from '../Popover/Popover.es.js';
import '../Popover/PopoverContext.es.js';
import { Avatar as Avatar$1 } from '../Avatar/Avatar.es.js';
import { Tooltip } from '../Tooltip/Tooltip.es.js';
import Button from '../Button/Button.es.js';
import { Scrollable } from '../Scrollable/Scrollable.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';
import '../../utils/assertions.es.js';
import { runIfFn } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { filterChildrenByType } from '../../utils/filterChildrenByType/filterChildrenByType.es.js';
import { AvatarWrapper, Avatar } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var AvatarComponent = forwardRef(function (props, ref) {
  var _a = props,
      src = _a.src,
      fallback = _a.fallback,
      size = _a.size,
      alt = _a.alt,
      name = _a.name,
      _a$wrapper = _a.wrapper,
      WrapperComponent = _a$wrapper === void 0 ? React.Fragment : _a$wrapper,
      wrapperProps = _a.wrapperProps,
      _a$hasTooltip = _a.hasTooltip,
      hasTooltip = _a$hasTooltip === void 0 ? true : _a$hasTooltip,
      rest = __objRest(_a, ["src", "fallback", "size", "alt", "name", "wrapper", "wrapperProps", "hasTooltip"]);

  return (
    /* @__PURE__ */
    React.createElement(AvatarWrapper, __spreadValues({
      ref: ref,
      size: size
    }, rest),
    /* @__PURE__ */
    React.createElement(WrapperComponent, __spreadValues({}, wrapperProps),
    /* @__PURE__ */
    React.createElement(ConditionalWrapper, {
      condition: hasTooltip,
      wrapper: function wrapper(children) {
        return (
          /* @__PURE__ */
          React.createElement(Tooltip, {
            position: "top",
            content: name ? name : fallback ? fallback : ""
          }, children)
        );
      }
    },
    /* @__PURE__ */
    React.createElement(Avatar, {
      src: src,
      fallback: fallback,
      size: size,
      alt: alt
    }))))
  );
});
AvatarComponent.displayName = "AvatarGroup.Avatar";
var popoverPropsDefault = {
  placement: "bottom-end",
  minWidth: "240px",
  maxWidth: "360px",
  maxHeight: "360px",
  overflow: "hidden",
  display: "flex"
};
var AvatarGroupComponent = forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      _a$size = _a.size,
      size = _a$size === void 0 ? "md" : _a$size,
      _a$limit = _a.limit,
      limit = _a$limit === void 0 ? 4 : _a$limit,
      total = _a.total,
      _a$hasPopover = _a.hasPopover,
      hasPopover = _a$hasPopover === void 0 ? false : _a$hasPopover,
      onTriggerClick = _a.onTriggerClick,
      _a$popoverProps = _a.popoverProps,
      popoverPropsProp = _a$popoverProps === void 0 ? {} : _a$popoverProps,
      popoverContent = _a.popoverContent,
      rest = __objRest(_a, ["children", "size", "limit", "total", "hasPopover", "onTriggerClick", "popoverProps", "popoverContent"]);

  var avatars = filterChildrenByType(children, AvatarComponent);
  var visibleAvatars = avatars.slice(0, limit).map(function (child, index) {
    return (
      /*#__PURE__*/
      React.cloneElement(child, {
        size: size,
        key: "avatar-" + index,
        zIndex: limit - index
      })
    );
  });
  var extraAvatars = avatars.slice(limit).map(function (child, index) {
    var _a2 = child.props,
        name = _a2.name,
        rest2 = __objRest(_a2, ["name"]);

    return (
      /* @__PURE__ */
      React.createElement(List.Item, {
        key: "list-item-" + index
      },
      /* @__PURE__ */
      React.createElement(List.ItemIcon, null,
      /* @__PURE__ */
      React.createElement(Avatar$1, __spreadValues({}, rest2))), name)
    );
  });
  var nbOfExtraAvatars = avatars.length > limit ? avatars.length - limit : 0;
  var truncatedAvatars = total ? Math.max(nbOfExtraAvatars, total - Math.min(avatars.length, limit)) : nbOfExtraAvatars;

  var popoverProps = __spreadValues(__spreadValues({}, popoverPropsDefault), popoverPropsProp);

  return (
    /* @__PURE__ */
    React.createElement(Flex, __spreadValues({
      ref: ref
    }, rest), visibleAvatars, !!truncatedAvatars &&
    /* @__PURE__ */
    React.createElement(Box, {
      ml: "xxs"
    }, hasPopover ?
    /* @__PURE__ */
    React.createElement(Popover, __spreadValues({}, popoverProps), function (_ref) {
      var close = _ref.close;
      return (
        /* @__PURE__ */
        React.createElement(React.Fragment, null,
        /* @__PURE__ */
        React.createElement(Popover.Trigger, null,
        /* @__PURE__ */
        React.createElement(Button, {
          variant: "ghost",
          size: size,
          isRounded: true
        }, "+" + truncatedAvatars)),
        /* @__PURE__ */
        React.createElement(Popover.Content, {
          p: 0
        }, popoverContent ? runIfFn(popoverContent, {
          close: close
        }) :
        /* @__PURE__ */
        React.createElement(Scrollable, null,
        /* @__PURE__ */
        React.createElement(List, {
          py: "xs"
        }, extraAvatars))))
      );
    }) :
    /* @__PURE__ */
    React.createElement(Button, {
      as: "span",
      variant: "ghost",
      size: size,
      isRounded: true,
      onClick: onTriggerClick
    }, "+" + truncatedAvatars)))
  );
});
AvatarGroupComponent.displayName = "AvatarGroup";
var AvatarGroup = Object.assign(AvatarGroupComponent, {
  Avatar: AvatarComponent
});
export { AvatarGroup };